import React, { useState } from "react";

const SelectAssetIdsPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showSelectAssetIdsPopup, setShowSelectAssetIdsPopup] =
      useState<boolean>(false);

    const selectAssetIdsToggleHandler = () => {
      setShowSelectAssetIdsPopup(!showSelectAssetIdsPopup);
    };

    return (
      <Component
        showSelectAssetIdsPopup={showSelectAssetIdsPopup}
        selectAssetIdsToggleHandler={selectAssetIdsToggleHandler}
        {...props}
      />
    );
  };

export default SelectAssetIdsPopupHOC;
